module.exports = __webpack_public_path__ + "static/media/cafe24-stock-integration.3ce7a4cb.png";